"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Radio2 = _interopRequireDefault(require("@material-ui/core/Radio"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _RadioButton = _interopRequireDefault(require("./RadioButton.styles"));

var _excluded = ["className", "error"];

function RadioButton(props) {
  var _classNames;

  var className = props.className,
      error = props.error,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _RadioButton.default)();
  return /*#__PURE__*/_react.default.createElement(_Radio2.default, Object.assign({}, otherProps, {
    checkedIcon: /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.checkedIcon, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.iconRed, error), (0, _defineProperty2.default)(_classNames, classes.checkedIconRed, error), _classNames))
    }),
    icon: /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconRed, error))
    }),
    className: (0, _classnames.default)('pds-radio', classes.root, className, {
      'pds-error': !!error
    }),
    color: "primary",
    disableRipple: true
  }));
}

RadioButton.propTypes = {
  /** A CSS class to add to the root node of the component. */
  className: _propTypes.string,

  /**
   * If true, the component is checked.
   */
  checked: _propTypes.bool,

  /**
   * If true, the component will be disabled.
   */
  disabled: _propTypes.bool,

  /**
   * If true, the control will have error state styling.
   */
  error: _propTypes.bool,

  /**
   * The id of the input element.
   */
  id: _propTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the input element.
   */
  inputProps: _propTypes.object,

  /**
   * Name attribute of the input element.
   */
  name: _propTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing event.target.value (string).
   * You can pull out the new checked state by accessing event.target.checked (boolean).
   */
  onChange: _propTypes.func,

  /**
   * If true, the input element will be required.
   */
  required: _propTypes.bool,

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: _propTypes.any
};
var _default = RadioButton;
exports.default = _default;
